import { storage } from "./storage";
import { SUPPORT_SESSION_KEY } from "../pages/SupportSessionAccept";

/**
 * Resolve active Manager → Portal platform-support session metadata.
 * Prefers profile.support_session; falls back to localStorage handoff payload.
 */
export function readPlatformSupportSessionMeta(user) {
  if (user?.is_platform_support && user?.support_session) {
    return user.support_session;
  }
  return storage.localStorage.get(SUPPORT_SESSION_KEY) || null;
}

/**
 * True when the current staff identity is an unexpired platform-support session.
 * Used to bypass subscription UI gates so support can help coops with missing/expired plans.
 */
export function isActivePlatformSupportSession(user) {
  const meta = readPlatformSupportSessionMeta(user);
  if (!meta?.expires_at) {
    return false;
  }

  // Require support identity from profile once hydrated; allow handoff meta briefly.
  if (!user?.is_platform_support && !meta?.admin_name && !meta?.display_name) {
    return false;
  }

  const expiresMs = new Date(meta.expires_at).getTime();
  if (!Number.isFinite(expiresMs)) {
    return false;
  }

  return expiresMs > Date.now();
}
